<template>
    <footer>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-auto rwdorder2">
                    <p>COPYRIGHT © 2018 NONG-NONG GROUP LIMITED ALL RIGHTS RESERVED.</p>
                </div>
                <div class="col-md-3 rwdorder1">
                    <div class="row">
                        <div class="col-6 col-md-12">
                            <div class="row">
                                <div class="col-auto col-md-2 iconBox" v-for="(item, index) in iconItem" v-bind:key="index">
                                    <a :href="item.link" target="_blank" class="posr">
                                        <img :src="require(`@/assets/images/icon/${item.pic}.png`)">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="activity posa">
                                <a href="javascript:;" class="hoverFill" v-b-modal.activity_modal>活動辦法</a>
                                <a href="javascript:;" class="hoverFill" v-b-modal.winning_modal>得獎名單</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data() {
            return {
                iconItem:[{
                        pic: 'icon0',
                        link: 'https://www.instagram.com/bellataiwan/',
                    },{
                        pic: 'icon1',
                        link: 'https://www.facebook.com/love.nongnong/',
                    },{
                        pic: 'icon2',
                        link: 'https://www.youtube.com/user/nongnongmagazine/',
                    },{
                        pic: 'icon3',
                        link: 'http://line.me/ti/p/%40jxa2097z',
                    },{
                        pic: 'icon4',
                        link: 'https://www.bella.tw/',
                }],
            }
        },
    }
</script>

